import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/wh-support-docs/wh-support-docs/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="top"></a>
    <p>{`Cúram by Merative™ supported operating systems, prerequisites, and supported software.`}</p>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Operating systems</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Prerequisites</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Supported software</AnchorLink>
    </AnchorLinks>
    <h2>{`Operating systems`}</h2>
    <a name="operating-systems"></a>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Microsoft Windows</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Linux</AnchorLink>
    </AnchorLinks>
    <h3>{`Microsoft Windows`}</h3>
    <p>{`The Microsoft® Windows® platform is supported for designing, developing, testing, and building the application on a server.`}</p>
    <h4>{`Windows 11 Enterprise x86-64`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Bitness`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Base`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`23H2`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`24H2`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Future`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`64-Exploit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
      </tbody>
    </table>
    <h4>{`Windows 11 Pro x86-64`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Bitness`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Base`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`23H2`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`24H2`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Future`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`64-Exploit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
      </tbody>
    </table>
    <h4>{`Windows 10 Enterprise x86-64`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Bitness`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Base`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Anniversary Update`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Creator’s Update`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Fall Creator’s Update`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`April 2018 Update`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`1809`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`1903`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`1909`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`2004`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`20H2`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`21H1`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`21H2`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`22H2`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Future`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`64-Exploit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
      </tbody>
    </table>
    <h4>{`Windows 10 Pro x86-64`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Bitness`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Base`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Anniversary Update`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Creator’s Update`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Fall Creator’s Update`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`April 2018 Update`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`1809`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`1903`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`1909`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`2004`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`20H2`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`21H1`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`21H2`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`22H2`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Future`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`64-Exploit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Linux`}</h3>
    <p>{`The Linux® platform is supported for building the application on a server.`}</p>
    <h4>{`Red Hat® Enterprise Linux (RHEL) 8 x86-64`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Bitness`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Base`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`8.1`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`8.2`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`8.3`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`8.4`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`8.5`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`8.6`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`8.7`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`8.8`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Future`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`64-Exploit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
      </tbody>
    </table>
    <p><a parentName="p" {...{
        "href": "#operating-systems"
      }}>{`Back to Operating systems`}</a></p>
    <p><a parentName="p" {...{
        "href": "#top"
      }}>{`Back to top`}</a></p>
    <h2>{`Prerequisites`}</h2>
    <h3>{`Installation`}</h3>
    <p>{`The supported platforms for the Merative™ Social Program Management installers are Linux and Windows.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Prerequisite`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Version`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`IBM® Runtime Environment, Java Technology Edition`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`8 and future fix packs`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Oracle Java SDK/JRE/JDK`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`8.0 and future fix packs`}</td>
        </tr>
      </tbody>
    </table>
    <p><a parentName="p" {...{
        "href": "#top"
      }}>{`Back to top`}</a></p>
    <h2>{`Supported software`}</h2>
    <a name="suppported-software"></a>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "#accessibility"
          }}>{`Accessibility`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "#application-servers"
          }}>{`Application servers`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "#databases"
          }}>{`Databases`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "#development-tools"
          }}>{`Development Tools`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "#reporting-and-analysis"
          }}>{`Reporting and Analysis`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "#web-browser-plug-ins"
          }}>{`Web Browser Plug-Ins`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "#web-browsers"
          }}>{`Web browsers`}</a></p>
      </li>
    </ul>
    <h3>{`Accessibility`}</h3>
    <p>{`The following accessibility software is supported.`}</p>
    {
      /*See the [Merative Social Program Management accessibility information](https://www.ibm.com/docs/en/spm/8.0.2?topic=overview-accessibility-in-social-program-management) for supported text resizing and browser zoom settings.*/
    }
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Supported software`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Version`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Browser`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Freedom Scientific JAWS screen reader`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`2023 and future fix packs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Microsoft Edge and `}<a parentName="td" {...{
              "href": "http://www.freedomscientific.com/products/blindness/jaws"
            }}>{`JAWS`}</a>{` 2023 is the only certified screen reader and browser combination.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Apple VoiceOver`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Any version and future fix packs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Google Chrome 114 and VoiceOver on iPad with iOS 15.7 is the certified combination for tablets.`}</td>
        </tr>
      </tbody>
    </table>
    <p><a parentName="p" {...{
        "href": "#supported-software"
      }}>{`Back to Supported software`}</a></p>
    <h3>{`Application Servers`}</h3>
    <p>{`For the supported operating systems and necessary configuration information for these application servers, see the `}<a parentName="p" {...{
        "href": "http://www.ibm.com/support/docview.wss?uid=swg27006921"
      }}>{`IBM® WebSphere® Application Server product site`}</a>{` or the `}<a parentName="p" {...{
        "href": "https://www.oracle.com/middleware/technologies/weblogic.html"
      }}>{`Oracle WebLogic Server product site`}</a>{` documentation.`}</p>
    <p>{`Container and Kubernetes platforms are not supported on these application servers.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Supported software`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Version`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Details`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Oracle WebLogic Server 12c`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`(12.2.1.4.0) and future patches`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The JDK (Java Development Kit) version 8 (and future fix packs) compatible with the WebLogic Server installation is supported. `}<br /><strong parentName="td">{`Note:`}</strong>{` Oracle Database is the only database that is supported for use with Oracle WebLogic Server.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Oracle WebLogic Server 14c`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`(14.1.1.0.0) and future patches`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The JDK (Java Development Kit) version 8 (and future fix packs) compatible with the WebLogic Server installation is supported. Later JDK versions (e.g. JDK 11) are not supported. `}<br /><strong parentName="td">{`Note:`}</strong>{` Oracle Database is the only database that is supported for use with Oracle WebLogic Server.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`IBM WebSphere Application Server`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`9.0.5 and future fix packs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The JDK (Java Development Kit) version 8 (and future fix packs) supplied with the WebSphere Application Server installation is supported.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`IBM WebSphere Application Server Network Deployment`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`9.0.5 and future fix packs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The JDK (Java Development Kit) version 8 (and future fix packs) supplied with the IBM WebSphere Application Server installation is supported.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`IBM WebSphere Application Server for z/OS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`9.0.5 and future fix packs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The JDK (Java Development Kit) version 8 (and future fix packs) supplied with the IBM WebSphere Application Server installation is supported.`}</td>
        </tr>
      </tbody>
    </table>
    <p><a parentName="p" {...{
        "href": "#supported-software"
      }}>{`Back to Supported software`}</a></p>
    <h3>{`Databases`}</h3>
    <p>{`For the supported operating systems and necessary configuration information for these databases, see the database product documentation.`}</p>
    <p>{`Database-as-a-Service or Container and Kubernetes platforms are not supported on these databases.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Supported software`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Version`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Details`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`IBM® Db2® Enterprise Server Edition`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`11.5.5.0 and future fix packs`}<br />{`11.5.6.0 and future fix packs`}<br />{`11.5.7.0 and future fix packs`}<br />{`11.5.8.0 and future fix packs`}<br /></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Reporting: `}<br />{`- - SPM Reporting and Analytics is supported on DB2 version 11.5.5.0 and future fix packs, mod levels and their fix packs. `}<br />{`- The SPM data warehouse can be built on this version of Db2. `}<br />{`- Reporting ETLs can be built using a technology compatible with this version of Db2. Database-as-a-Service is not supported. Container and Kubernetes Platforms are not supported.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`IBM Db2 for z/OS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`12.1 and future fix packs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`When using SPM with Db2 for z/OS, the provided db2jcc4.jar file in the $CURAMSDEJ/drivers folder is used to access Db2 for z/OS whether access is local to z/OS or via a remote deployment. However, the level of Db2 for z/OS may have dependencies with the client JDBC driver level; therefore, see the `}<a parentName="td" {...{
              "href": "https://www.ibm.com/support/pages/node/405457"
            }}>{`IBM Data Server Driver for JDBC and SQLJ versions and Db2 for z/OS APARs`}</a>{` page for supported Db2 and JDBC levels.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`H2 Database`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1.3.176 or future fix packs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`H2 is only supported for use in the development environment to aid application design, development and testing. The supported platforms are Windows 10. H2 is not supported for use with IBM Websphere Application Server or Oracle WebLogic Server. See the H2 site for further information and technical support.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`IBM Db2 Advanced Enterprise Server Edition`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`11.5.5.0 and future fix packs`}<br />{`11.5.6.0 and future fix packs`}<br />{`11.5.7.0 and future fix packs`}<br />{`11.5.8.0 and future fix packs`}<br /></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Reporting: `}<br />{`- - SPM Reporting and Analytics is supported on DB2 version 11.5.5.0 and future fix packs, mod levels and their fix packs. `}<br />{`- The SPM data warehouse can be built on this version of Db2. `}<br />{`- Reporting ETLs can be built using a technology compatible with this version of Db2. Database-as-a-Service is not supported. Container and Kubernetes Platforms are not supported.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`IBM Db2 Standard Edition VPC Option`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`11.5.5.0 and future fix packs`}<br />{`11.5.6.0 and future fix packs`}<br />{`11.5.7.0 and future fix packs`}<br />{`11.5.8.0 and future fix packs`}<br /></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Database-as-a-Service is not supported. Container and Kubernetes Platforms are not supported.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Oracle Database 19c`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`(19.3) and future Release Updates (RU)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`(19.3) Enterprise Edition and future Release Updates (RU)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Reporting: `}<br />{`- Only the Enterprise Edition of Oracle Database 19c is supported for Curam Reporting.`}<br />{`- See the `}<a parentName="td" {...{
              "href": "https://www.oracle.com/database/"
            }}>{`Oracle Database product site`}</a>{` for certified configuration information on this product.`}<br />{`- Curam Reporting has been certified against Oracle 19c as a source database to host the Social Program Management Application database and as a target database to host Reporting databases.`}</td>
        </tr>
      </tbody>
    </table>
    <p><a parentName="p" {...{
        "href": "#supported-software"
      }}>{`Back to Supported software`}</a></p>
    <h3>{`Development Tools`}</h3>
    <p>{`Although technical support is not provided for any Integrated Development Environment (IDE) it should be possible to use any Java IDE for development. Support for IDEs should be sought from the relevant software vendor. The following IDEs have been tested, and their use is described in the documentation.`}</p>
    <p>{`Note that the development of the application is restricted to the Windows platform (Windows 7 and 10) and the listed tools have been tested only on that platform.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Supported software`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Version`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Details`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Apache Ant`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1.10.6`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Please note that only Apache Ant 1.10.6 is supported. Associated fix packs are not.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Eclipse`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`4.18 and future fix packs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Eclipse 4.18.0 and `}<a parentName="td" {...{
              "href": "https://www.eclipse.org/downloads/packages/release/Neon/3"
            }}>{`higher maintenance releases`}</a>{`. Servlet Containers/Application Servers: Apache Tomcat `}<a parentName="td" {...{
              "href": "https://archive.apache.org/dist/tomcat/tomcat-9/v9.0.50/"
            }}>{`9.0.50`}</a>{`, with `}<a parentName="td" {...{
              "href": "https://sourceforge.net/projects/tomcatplugin/files/updatesite/plugins/"
            }}>{`Eclipse Tomcat Plugin`}</a>{` 9.0.1. Java SE: IBM and Oracle Java SE JDK 8.0 and `}<a parentName="td" {...{
              "href": "http://www.oracle.com/technetwork/java/javase/downloads/index.html"
            }}>{`higher updates`}</a>{`. Java EE: Oracle Java EE 6 and 7 and `}<a parentName="td" {...{
              "href": "http://www.oracle.com/technetwork/java/javaee/downloads/java-archive-downloads-eesdk-419427.html"
            }}>{`higher updates`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Rational Software Architect Designer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`9.5.0.1`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Supported as a Modeling Environment. Servlet Containers/Application Servers: Apache Tomcat 9.0.50, with Eclipse Tomcat Plugin 9.0.1. Java SE: IBM and Oracle Java SE JDK 8.0 and higher updates. Java EE: Oracle Java EE 6 and 7 and higher updates.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Rational Software Architect Designer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`9.7.1.2`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Recommended version for the Windows 11 platform`}</strong>{`. Supported as a Modeling Environment. Servlet Containers/Application Servers: Apache Tomcat 9.0.50, with Eclipse Tomcat Plugin 9.0.1. Java SE: IBM and Oracle Java SE JDK 8.0 and higher updates. Java EE: Oracle Java EE 6 and 7 and higher updates.`}</td>
        </tr>
      </tbody>
    </table>
    <p><a parentName="p" {...{
        "href": "#supported-software"
      }}>{`Back to Supported software`}</a></p>
    <h3>{`Reporting and Analysis`}</h3>
    <p>{`Eclipse Business Intelligent and Reporting Tools (BIRT) is an open source component that provides a development and execution environment for Social Program Management Business Intelligence (BI) content.`}</p>
    <p>{`The use of a second Eclipse instance for BIRT development is recommended as standard Social Program Management development often requires an Eclipse version that is not compatible with the certified BIRT development environment.`}</p>
    <p>{`For more information, see the Development Environment Installation Guide and the BIRT Developer Guide.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Supported software`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Version`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Details`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Eclipse Business Intelligence and Reporting Tools`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`4.8.0 and future fix packs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Social Program Management uses the all-in-one installation. For more information, see `}<a parentName="td" {...{
              "href": "https://download.eclipse.org/birt/downloads/drops/"
            }}>{`BIRT versions and platform support`}</a>{`.`}</td>
        </tr>
      </tbody>
    </table>
    <p><a parentName="p" {...{
        "href": "#supported-software"
      }}>{`Back to Supported software`}</a></p>
    <h3>{`Web Browser Plug-Ins`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Supported software`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Version`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Details`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Adoptium OpenJDK`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`8 and future fix packs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Java is required for Microsoft Word Integration. Adoptium OpenJDK Version 8.0 is available as a free download from the `}<a parentName="td" {...{
              "href": "https://adoptium.net"
            }}>{`Adoptium Home Page`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Microsoft Word`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`2019 and future fix packs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Required for creating and editing Social Program Management communication documents in Microsoft Word format.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`2021 and future fix packs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Oracle Java SDK/JRE/JDK`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`8.0 and future fix packs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Java is required for Microsoft Word Integration. JRE 8.0 - the most recently released version tested is JRE 1.8 u371. Available to download from the `}<a parentName="td" {...{
              "href": "https://www.oracle.com/java/technologies/downloads"
            }}>{`Oracle Java downloads page`}</a>{`.`}</td>
        </tr>
      </tbody>
    </table>
    <p><a parentName="p" {...{
        "href": "#supported-software"
      }}>{`Back to Supported software`}</a></p>
    <h3>{`Web browsers`}</h3>
    <p>{`The minimum recommended resolution is 1366x768. The optimum DPI setting is Normal size.`}</p>
    <p>{`Chrome, Firefox, Edge, and Safari release new versions frequently and install updates automatically by default. Merative Social Program Management releases (V.R.M.F releases only) are generally tested on the latest version (for Chrome and Edge, stable releases only) of these browsers available at the start of the development cycle; if tested with no issues Merative will certify that version. The prerequisites advise the version that is certified at each new product release. If for any reason, Merative Social Program Management are unable to certify for that version, it may be necessary to revert back to a version that is previously fully certified. While Merative will support customers on newer versions of these browsers than the last certified version, they should understand that they have not been fully tested.`}</p>
    <h4>{`Standard desktop browser support`}</h4>
    <p>{`While every effort is made to ensure that internal case worker application pages use standard web technologies and formats that are compatible with all browsers, only the listed browsers are officially supported.`}</p>
    <h4>{`Universal Access desktop browser support`}</h4>
    <p>{`Universal Access has been specifically developed for public facing applications so browser support has been extended in this area.`}</p>
    <ul>
      <li parentName="ul">{`For information about browser support for the Universal Access Responsive Web Application, see the prerequisites and supported software in the `}<a parentName="li" {...{
          "href": "/wh-support-docs/spm/pdf-documentation#citizen-engagement"
        }}>{`Universal Access Responsive Web Application documentation`}</a>{`.`}</li>
      <li parentName="ul">{`While every effort is made to ensure that the classic Universal Access application uses standard web technologies and formats that are compatible with all browsers, only the listed browsers are officially supported.`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Supported software`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Version`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Details`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Google Chrome`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`114 and future fix packs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This browser is supported for both the Universal Access and Case Worker applications. Microsoft Word Integration  and Arabic (RTL) are supported for this browser in the Case Worker application.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Microsoft Edge`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`114 and future fix packs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This browser is supported for both the Universal Access and Case Worker applications. Microsoft Word Integration  and Arabic (RTL) are supported for this browser in the Case Worker application.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Mozilla Firefox`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`114 and future fix packs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This browser is supported only for the Universal Access application.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Apple Safari`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`16 and future fix packs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This browser is supported only for the Universal Access application.`}</td>
        </tr>
      </tbody>
    </table>
    <h4>{`Tablet browser support`}</h4>
    <p>{`Google Chrome 114 and future fix packs are supported for tablet devices.`}</p>
    <p><a parentName="p" {...{
        "href": "#supported-software"
      }}>{`Back to Supported software`}</a></p>
    <p><a parentName="p" {...{
        "href": "#top"
      }}>{`Back to top`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      